import { render, staticRenderFns } from "./PermissionsPanel.vue?vue&type=template&id=101e6f5a&scoped=true"
import script from "./PermissionsPanel.vue?vue&type=script&lang=js"
export * from "./PermissionsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101e6f5a",
  null
  
)

export default component.exports